<template>
  <div>
    <div class="w-full mx-auto | container">
      <div class="w-full flex items-center | breadcrumbs">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs"
}
</script>

<style lang="scss" scoped>
</style>
